import { render, staticRenderFns } from "./VueChartkick.vue?vue&type=template&id=d1df0f88&scoped=true"
import script from "./VueChartkick.vue?vue&type=script&lang=js"
export * from "./VueChartkick.vue?vue&type=script&lang=js"
import style0 from "./VueChartkick.vue?vue&type=style&index=0&id=d1df0f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1df0f88",
  null
  
)

export default component.exports